import urlParser from "js-video-url-parser";

require('./bootstrap');

window.urlParser = urlParser;
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from 'vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

Vue.config.ignoredElements = ['custom-embed'];

Vue.component('apply-to-job-offer', require('./components/ApplyToJobOffer').default)
Vue.component('favorite-account-toggler', require('./components/FavoriteAccountToggler').default)
Vue.component('file-input', require('./components/FileInput').default)
Vue.component('form-child', require('./components/FormChild').default)
Vue.component('form-with-validation', require('./components/FormWithValidation').default)
Vue.component('guest-modal', require('./components/GuestModal').default)
Vue.component('info-button', require('./components/InfoButton').default)
Vue.component('input-length', require('./components/InputLength').default)
Vue.component('home-popup', require('./components/HomePopup').default)
Vue.component('job-alert', require('./components/JobAlert').default)
Vue.component('login-modal', require('./components/LoginModal').default)
Vue.component('newsletter-popup', require('./components/NewsletterPopup').default)
Vue.component('radio-toggle', require('./components/RadioToggle').default)
Vue.component('register-modal', require('./components/RegisterModal').default)
Vue.component('responsive-owl', require('./components/ResponsiveOwl').default)
Vue.component('send-message-to-brand', require('./components/SendMessageToBrand').default)
Vue.component('showroom', require('./components/Showroom').default)
Vue.component('tooltip-modal', require('./components/TooltipModal').default)
Vue.component('video-link', require('./components/VideoLink').default)
Vue.component('video-player', require('./components/VideoPlayer').default)
Vue.component('video-thumbnail', require('./components/VideoThumbnail').default)


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = window.jQuery = $;

import clamp from 'clamp-js';

new Vue({
    methods: {
        setupChoicesMultiple(selectElement, options) {
            const choices = new Choices(selectElement, {
                removeItemButton: true,
                itemSelectText: '',
                shouldSort: false,
                ...options
            });

            selectElement.addEventListener('change', function () {
                const placeholder = choices.containerInner.element.querySelector('input[placeholder]')

                choices.getValue().length
                    ? placeholder.classList.add('hidden')
                    : placeholder.classList.remove('hidden')
            });

            selectElement.choicesInstance = choices

            return choices
        }
    },

    mounted() {
        require('./front')
        require('lightpick');
        require(['lightpick'], function (Lightpick) {
            window.Lightpick = Lightpick;

            [...document.getElementsByClassName('datepicker')].forEach(element => {
                element.setAttribute("autocomplete", "off");

                var datepicker = new Lightpick({
                    field: element,
                    lang: 'nl',
                    format: 'DD-MM-YYYY',
                })

                element.addEventListener("keydown", (event) => {
                    if (event.key == "Enter") {
                        event.preventDefault();
                    }

                    datepicker.hide()
                });

                element.datepicker = datepicker
            })
        });

        [...document.getElementsByClassName('choices-select-mulitple')].forEach((selectElement) => {
            this.setupChoicesMultiple(selectElement, {
                removeItemButton: true,
            })
        });

        const supportsNativeClamp = typeof (document.body.style.webkitLineClamp) != 'undefined';

        if (!supportsNativeClamp) {
            [...document.getElementsByClassName('line-clamp-2')].forEach((clampElement) => {
                clamp(clampElement, {
                    clamp: 2
                })
            });

            [...document.getElementsByClassName('line-clamp-3')].forEach((clampElement) => {
                clamp(clampElement, {
                    clamp: 3
                })
            });
        }
    }
}).$mount('#app');